import { BaseEntityModel } from '@/modules/core/app/models/abstracts/BaseEntityModel';
import { ClaraMessageObject } from '@/modules/ai/models/ClaraMessageObject';
import { ClaraConversationObject } from '@/modules/ai/models/ClaraConversationObject';

export class AskClaraQuestionResponseObject extends BaseEntityModel {
  question?: Relationship<ClaraMessageObject | null>;
  answer?: Relationship<ClaraMessageObject | null>;
  conversation?: Relationship<ClaraConversationObject | null>;

  constructor(model: Partial<AskClaraQuestionResponseObject> = {}) {
    super(model);

    this.question = ClaraMessageObject.mapModelOrNull(model.question);
    this.answer = ClaraMessageObject.mapModelOrNull(model.answer);
    this.conversation = ClaraConversationObject.mapModelOrNull(model.conversation);
  }

  get claraConversation(): ClaraConversationObject | undefined {
    return ClaraConversationObject.mapModel({
      ...this.conversation,
      messages: [this.question, this.answer] as ClaraMessageObject[]
    });
  }
}
